import BingoPatientProgressTable from 'components/atoms/bingo-progress-table';

import type { ModuleType } from 'infrastructure/enums';

interface IAdminTabbedFormBingoPatientProgressProps {
  patientGuid: string;
  module: ModuleType;
  readOnly?: boolean;
}

export default function AdminTabbedFormBingoProgress(
  props: IAdminTabbedFormBingoPatientProgressProps,
) {
  const { patientGuid, module, readOnly } = props;
  return (
    <BingoPatientProgressTable
      patientGuid={patientGuid}
      module={module}
      readOnly={readOnly}
    />
  );
}
